import PpCombobox from '@/components/Selectors/Combobox';

import {
  getCurrentCanvas,
  getUniqueStylesWithPropertyName,
  getValueInput,
  pxToPt,
  validateInputOption
} from '@/common/utils';
import {
  ICON_LOCAL,
  FONT_SIZE,
  PROPERTIES_SELECTION_FABRICS,
  TWO_EM_DASH
} from '@/common/constants';
import { cloneDeep, isEmpty } from 'lodash';
import { useAppCommon, useProperties } from '@/hooks';

export default {
  components: {
    PpCombobox
  },
  props: {
    nudgeWidth: {
      type: Number,
      default: 76
    },
    selectedSize: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isTextProperties: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const { currentSelectionTextStyle } = useAppCommon();
    const { getProperty } = useProperties();
    return {
      getProperty,
      currentSelectionTextStyle
    };
  },
  data() {
    return {
      componentKey: true,
      appendedIcon: ICON_LOCAL.APPENDED_ICON,
      prependedIcon: ICON_LOCAL.PREPENDED_FONT_SIZE,
      selectedSizeWhenSelection: null
    };
  },
  computed: {
    fontSize() {
      this.componentKey = !!this.componentKey;
      if (!this.isTextProperties) return FONT_SIZE;
      const listFontSize = cloneDeep(FONT_SIZE);
      const listStyle = getUniqueStylesWithPropertyName(
        PROPERTIES_SELECTION_FABRICS.FONT_SIZE,
        this.currentSelectionTextStyle
      );
      if (!listStyle.length) {
        this.selectedSizeWhenSelection = {
          name: `${this.getProperty(
            PROPERTIES_SELECTION_FABRICS.FONT_SIZE
          )} pt`,
          value: this.getProperty(PROPERTIES_SELECTION_FABRICS.FONT_SIZE)
        };

        return listFontSize;
      }
      return this.handleReturnFontSize(listStyle, listFontSize);
    }
  },
  methods: {
    /**
     * Emit to back value to parent
     * @param {Any} data size of text (string or object)
     */
    onChange(data) {
      if (data.value === TWO_EM_DASH) {
        this.forceRenderComponent();
        return;
      }
      const { isValid, value } = validateInputOption(
        getValueInput(data),
        1,
        500,
        0,
        this.fontSize,
        'pt'
      );
      this.forceRenderComponent();
      if (!isValid) {
        return;
      }
      this.$emit('change', { fontSize: value });
    },
    /**
     * Trigger render component by changing component key
     */
    forceRenderComponent() {
      this.componentKey = !this.componentKey;
    },
    roundFontValue(size) {
      return Math.round(size);
    },
    handleReturnFontSize(listStyle, listFontSize) {
      const canvas = getCurrentCanvas();

      if (listStyle.length === 1) {
        if (
          canvas.getActiveObject().type === 'group' &&
          this.getProperty(PROPERTIES_SELECTION_FABRICS.FONT_SIZE) !==
            this.roundFontValue(
              pxToPt(listStyle[0][PROPERTIES_SELECTION_FABRICS.FONT_SIZE])
            )
        ) {
          listFontSize.unshift({
            name: TWO_EM_DASH,
            value: TWO_EM_DASH
          });
          this.selectedSizeWhenSelection = listFontSize[0];
          return listFontSize;
        }
        this.selectedSizeWhenSelection = listFontSize.find(
          item =>
            item.value ===
            this.roundFontValue(
              pxToPt(listStyle[0][PROPERTIES_SELECTION_FABRICS.FONT_SIZE])
            )
        ) || {
          name: `${this.roundFontValue(
            pxToPt(listStyle[0][PROPERTIES_SELECTION_FABRICS.FONT_SIZE])
          )} pt`,
          value: this.roundFontValue(
            pxToPt(listStyle[0][PROPERTIES_SELECTION_FABRICS.FONT_SIZE])
          )
        };
        return listFontSize;
      } else {
        if (canvas.getActiveObject().type === 'group') {
          listFontSize.unshift({
            name: TWO_EM_DASH,
            value: TWO_EM_DASH
          });
          this.selectedSizeWhenSelection = listFontSize[0];
          return listFontSize;
        }
        const listStyleRemoveEmpty = listStyle
          .filter(item => !isEmpty(item))
          .filter(item => !item[PROPERTIES_SELECTION_FABRICS.FONT_SIZE]);
        // if lenght is diff , it's we have text have portion format and text global format
        if (listStyleRemoveEmpty.length !== listStyle.length) {
          if (
            listStyleRemoveEmpty.length === 1 &&
            this.getProperty(PROPERTIES_SELECTION_FABRICS.FONT_SIZE) ===
              this.roundFontValue(
                pxToPt(
                  listStyleRemoveEmpty[0][
                    PROPERTIES_SELECTION_FABRICS.FONT_SIZE
                  ]
                )
              )
          ) {
            this.selectedSizeWhenSelection = null;
            return listFontSize;
          }
          listFontSize.unshift({
            name: TWO_EM_DASH,
            value: TWO_EM_DASH
          });
          this.selectedSizeWhenSelection = listFontSize[0];
          return listFontSize;
        }
        this.selectedSizeWhenSelection = null;
        return listFontSize;
      }
    }
  }
};
